import { render, staticRenderFns } from "./yunying.vue?vue&type=template&id=f5df5388&scoped=true"
import script from "./yunying.vue?vue&type=script&lang=js"
export * from "./yunying.vue?vue&type=script&lang=js"
import style0 from "./yunying.vue?vue&type=style&index=0&id=f5df5388&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5df5388",
  null
  
)

export default component.exports